import React from 'react';
import { FaFillDrip, FaReact } from "react-icons/fa";
import "./Service.css";

const Services = () => {
    return (
        <div className='pt-28 overflow-x-hidden' id='service'>

            <div className="w-[95vw] sm:w-[80vw] lg:w-[60vw] mx-auto pb-20">
                <div className='text-center space-y-8'>
                    <h4 data-aos="fade-right" className='uppercase text-lg text-white font-thin tracking-[6px]'>Best Features</h4>
                    <h2 data-aos="fade-left" className='text-4xl md:text-6xl color-font'>My Best Services</h2>
                </div>

                <div className="grid grid-cols-2 gap-8 mt-20 serviceBg">

                    <div data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000" className='text-center bg-[#0c0c0f]/60 backdrop-blur-md space-y-10 p-10 col-span-2 sm:col-span-1'>
                        <div className="text-center">
                            <FaFillDrip className="text-6xl mx-auto" />
                        </div>
                        <div className='space-y-5'>
                            <h4 className='text-2xl text-white'>Web Design</h4>
                            <p className='text-base text-slate-300 font-thin'>Focuses on the visual aesthetics and user experience of a website, including layout, colors, and navigation to create an appealing and user-friendly interface.</p>
                        </div>
                    </div>

                    <div data-aos="flip-right" data-aos-easing="ease-out-cubic" data-aos-duration="2000" className='text-center bg-[#0c0c0f]/60 backdrop-blur-md space-y-10 p-10 col-span-2 sm:col-span-1'>
                        <div className="text-center">
                            <FaReact className="text-6xl mx-auto" />
                        </div>
                        <div className='space-y-5'>
                            <h4 className='text-2xl text-white'>Web Development (MERN)</h4>
                            <p className='text-base text-slate-300 font-thin'>Involves building and maintaining the website's structure and functionality using coding languages and frameworks, covering both front-end (client-side) and back-end (server-side) development.</p>
                        </div>
                    </div>

                </div>
            </div>

            <div className="w-3/5 h-1 bg-gradient-to-l from-neutral-content absolute right-0 z-50 mt-5"></div>

        </div>
    );
};

export default Services;